import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function XLine({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M3 3L13 13M13 3L3 13" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
        </svg>
    );
}

export default XLine;
